/*
  Product reviews (sections/product-reviews.liquid, KAN-733).

  Reads the review markup Judge.me server-renders inside the section's app
  block and rebuilds it as the At-Home review summary, rating bars and cards.
  Runs synchronously right after the section markup, before Judge.me's own
  deferred scripts restructure that markup, so nothing flashes.

  Judge.me stays in charge of submitting and listing reviews: the section's
  "Write a review" and "Read all" buttons click the matching Judge.me controls
  inside the invisible widget. If the Judge.me markup is not found, the
  section never adds .product-reviews--enhanced, so product-reviews.css keeps
  its own summary hidden and the widget shows as usual.
*/
(function () {
  if (window.OlfProductReviews) return;

  var RETRY_MS = 400;
  var RETRY_LIMIT = 15;

  function text(node) {
    return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function stars(score) {
    var out = '';
    for (var i = 1; i <= 5; i += 1) {
      out += i <= score ? '★' : '<span class="rsum-star-empty">★</span>';
    }
    return out;
  }

  function el(tag, className, content) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (content) node.textContent = content;
    return node;
  }

  function formatDate(iso) {
    var date = new Date(iso);
    if (!iso || isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  }

  function readJudgeMe(provider) {
    var widget = provider.querySelector('.jdgm-rev-widg');
    if (!widget) return null;

    var histogram = {};
    provider.querySelectorAll('.jdgm-histogram__row[data-rating]').forEach(function (row) {
      histogram[row.getAttribute('data-rating')] = {
        count: parseInt(row.getAttribute('data-frequency'), 10) || 0,
        percent: parseFloat(row.getAttribute('data-percentage')) || 0
      };
    });

    var seen = {};
    var reviews = [];
    widget.querySelectorAll('.jdgm-rev[data-review-id]').forEach(function (rev) {
      var id = rev.getAttribute('data-review-id');
      if (seen[id]) return;
      seen[id] = true;
      var rating = rev.querySelector('.jdgm-rev__rating');
      var time = rev.querySelector('.jdgm-rev__timestamp');
      reviews.push({
        rating: rating ? parseInt(rating.getAttribute('data-score'), 10) || 0 : 0,
        verified: rev.getAttribute('data-verified-buyer') === 'true',
        date: formatDate(time && time.getAttribute('datetime')),
        author: text(rev.querySelector('.jdgm-rev__author')),
        title: text(rev.querySelector('.jdgm-rev__title')),
        body: text(rev.querySelector('.jdgm-rev__body'))
      });
    });

    return {
      average: parseFloat(widget.getAttribute('data-average-rating')) || 0,
      count: parseInt(widget.getAttribute('data-number-of-reviews'), 10) || 0,
      histogram: histogram,
      reviews: reviews
    };
  }

  function countLabel(root, count) {
    var template = count === 1 ? root.dataset.countLabelSingle : root.dataset.countLabel;
    return (template || '').replace('[count]', count.toLocaleString('en-US'));
  }

  function renderSummary(root, data) {
    var average = (Math.round(data.average * 10) / 10).toFixed(1);
    root.querySelector('[data-pr-average]').textContent = average;
    var averageStars = root.querySelector('[data-pr-average-stars]');
    averageStars.innerHTML = stars(Math.round(data.average));
    averageStars.setAttribute('aria-label', 'Rated ' + average + ' out of 5');
    root.querySelector('[data-pr-count]').textContent = countLabel(root, data.count);

    root.querySelectorAll('[data-pr-histogram] .rsum-bar-row').forEach(function (row) {
      var entry = data.histogram[row.getAttribute('data-rating')] || { count: 0, percent: 0 };
      row.querySelector('.rsum-bar-fill').style.width = entry.percent + '%';
      row.querySelector('.rsum-bar-stat').textContent = entry.count.toLocaleString('en-US');
      row.classList.toggle('is-zero', entry.count === 0);
    });
  }

  function buildCard(review) {
    var card = el('article', 'review-card');
    var meta = el('div', 'review-card-meta');
    if (review.sourceLabel) meta.appendChild(el('div', 'review-card-source', review.sourceLabel));
    if (review.date) meta.appendChild(el('span', 'review-card-date', review.date));
    card.appendChild(meta);

    var header = el('div', 'review-card-header');
    var cardStars = el('div', 'review-card-stars');
    cardStars.setAttribute('role', 'img');
    cardStars.setAttribute('aria-label', review.rating + ' out of 5 stars');
    cardStars.innerHTML = stars(review.rating);
    header.appendChild(cardStars);
    card.appendChild(header);

    if (review.title) card.appendChild(el('h3', 'review-card-title', review.title));
    var body = el('p', 'review-card-body is-clamped', review.body);
    card.appendChild(body);
    if (review.author) card.appendChild(el('div', 'review-card-author', review.author));
    return card;
  }

  function addReadMore(card) {
    var body = card.querySelector('.review-card-body');
    if (!body || body.scrollHeight <= body.clientHeight + 1) {
      if (body) body.classList.remove('is-clamped');
      return;
    }
    var more = el('button', 'product-reviews__more', 'Read more');
    more.type = 'button';
    more.setAttribute('aria-expanded', 'false');
    more.addEventListener('click', function () {
      var expanded = body.classList.toggle('is-clamped') === false;
      more.textContent = expanded ? 'Show less' : 'Read more';
      more.setAttribute('aria-expanded', String(expanded));
    });
    body.insertAdjacentElement('afterend', more);
  }

  function renderCards(root, data) {
    var max = parseInt(root.dataset.maxReviews, 10) || 6;
    var shown = data.reviews.slice(0, max);
    var track = root.querySelector('[data-pr-track]');
    track.textContent = '';
    track.setAttribute('data-count', String(shown.length));

    shown.forEach(function (review) {
      review.sourceLabel = review.verified ? root.dataset.verifiedLabel : root.dataset.unverifiedLabel;
      track.appendChild(buildCard(review));
    });
    track.querySelectorAll('.review-card').forEach(addReadMore);

    var layout = root.dataset.cardLayout || 'auto';
    var useCarousel = layout === 'carousel' || (layout === 'auto' && shown.length > 3);
    if (useCarousel) initCarousel(root, track);

    var readAll = root.querySelector('[data-pr-read-all]');
    if (data.count > shown.length) {
      readAll.textContent = (root.dataset.readAllLabel || '').replace('[count]', data.count.toLocaleString('en-US'));
      readAll.hidden = false;
    }
  }

  function initCarousel(root, track) {
    var carousel = root.querySelector('[data-pr-carousel]');
    var controls = carousel.querySelector('.reviews-carousel-controls');
    var prev = carousel.querySelector('[data-pr-prev]');
    var next = carousel.querySelector('[data-pr-next]');
    carousel.classList.add('reviews-carousel--enabled', 'reviews-carousel--controls-bottom-center');
    track.classList.add('reviews-grid--carousel');
    track.tabIndex = 0;
    controls.hidden = false;

    function step() {
      var card = track.querySelector('.review-card');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    }

    function update() {
      var maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= maxScroll - 1;
      controls.hidden = maxScroll <= 1;
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function isOpen(selector) {
    return Array.prototype.some.call(document.querySelectorAll(selector), function (node) {
      return node.getBoundingClientRect().height > 0;
    });
  }

  /* Clicks a Judge.me control inside the invisible widget, retrying while
     Judge.me is still loading. preventDefault keeps its href="#…" from
     jumping the page; Judge.me's own click handler still runs. */
  function openJudgeMe(root, controlSelector, openSelector) {
    var attempts = 0;
    function attempt() {
      if (isOpen(openSelector)) return;
      var control = root.querySelector('[data-pr-provider] ' + controlSelector);
      if (control) {
        control.addEventListener('click', function (event) { event.preventDefault(); }, { once: true });
        control.click();
      }
      attempts += 1;
      if (attempts < RETRY_LIMIT) window.setTimeout(attempt, RETRY_MS);
    }
    attempt();
  }

  function bindActions(root) {
    root.querySelectorAll('[data-pr-write]').forEach(function (button) {
      button.addEventListener('click', function () {
        openJudgeMe(root, '.jdgm-write-rev-link', '.jdgm-write-review-modal__container, .jdgm-form-wrapper');
      });
    });
    var readAll = root.querySelector('[data-pr-read-all]');
    readAll.addEventListener('click', function () {
      openJudgeMe(root, '.jdgm-row-readmore a, .jdgm-all-reviews-page__link', '.jdgm-widget__popup-content');
    });
  }

  /* Review-request emails link to #judgeme_product_reviews. The browser jumps
     there while the wizard above is still mounting and loading images, and
     Safari does not compensate when that content grows, so the reviews end up
     half a screen down. Keep the section pinned to the top of the viewport
     until the page settles, and let go as soon as the visitor scrolls. */
  var PIN_MS = 6000;
  var PIN_CHECK_MS = 150;

  function pinToAnchor(root) {
    var hash = decodeURIComponent(window.location.hash.slice(1));
    var anchor = root.querySelector('.reviews-section');
    if (!hash || (hash !== 'judgeme_product_reviews' && !(anchor && anchor.id === hash))) return;

    var released = false;
    var timer;
    function release() {
      released = true;
      window.clearInterval(timer);
      ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (type) {
        window.removeEventListener(type, release, true);
      });
    }
    function pin() {
      if (released) return;
      var top = root.getBoundingClientRect().top;
      if (Math.abs(top) > 1) window.scrollTo(0, window.pageYOffset + top);
    }
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (type) {
      window.addEventListener(type, release, { capture: true, passive: true });
    });
    timer = window.setInterval(pin, PIN_CHECK_MS);
    window.addEventListener('load', pin);
    window.setTimeout(release, PIN_MS);
    pin();
  }

  function init(root) {
    if (!root || root.dataset.prReady === 'true') return;
    root.dataset.prReady = 'true';

    var provider = root.querySelector('[data-pr-provider]');
    var data = provider && readJudgeMe(provider);
    if (!data) return;

    root.classList.add('product-reviews--enhanced');
    /* inert keeps the invisible widget out of the tab order and the
       accessibility tree, including markup Judge.me rebuilds after load. */
    provider.setAttribute('inert', '');
    provider.setAttribute('aria-hidden', 'true');

    var populated = root.querySelector('[data-pr-populated]');
    var empty = root.querySelector('[data-pr-empty]');
    populated.hidden = data.count === 0;
    empty.hidden = data.count !== 0;

    if (data.count > 0) {
      renderSummary(root, data);
      renderCards(root, data);
    }
    bindActions(root);
    pinToAnchor(root);
  }

  window.OlfProductReviews = { init: init };

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-product-reviews]');
    if (root) init(root);
  });
})();
